/**
* Amal Site
*/

/* eslint-env browser */
'use strict';
// Vendor imports
import { CountUp } from './vendor/countUp';
import aos from './vendor/aos';
import nav from './modules/nav';
import heroSlider from './modules/heroSlider';
import stats from './modules/stats';
import anchor from './modules/anchor';
import accordion from './modules/accordion';
import archiveSidebar from "./modules/archiveSidebar";

(function ($) {
  $(window).ready(function () {
    aos.init({
      once: true,
    });
    $(".select2").select2();

    nav();
    heroSlider();
    stats(CountUp);
    anchor();
    accordion();
    archiveSidebar();
  });
})(jQuery);
